import { CheckCircle2, AlertCircle } from 'lucide-react';
import { UploadDocument } from '../types';
import { getFileIcon } from '../../DocumentList/utils/getFileIcon';
import { useTranslation } from '@hooks/useTranslation';

interface DocumentItemProps {
  document: UploadDocument;
}

export const DocumentItem: React.FC<DocumentItemProps> = ({ document }) => {
  const tProjectComponents = useTranslation('projectComponents');
  const t = tProjectComponents.documents;
  const isUploading = document?.status === 'uploading';
  const isComplete = document?.status === 'completed';
  const isFailed = document?.status === 'failed';
  const progress = document?.progress ?? 100;

  return (
    <li className="flex items-center justify-between bg-gray-50 rounded px-3 py-2 shadow-sm hover:shadow-md transition">
      <div
        className={`flex items-center gap-3 w-4/5 ${
          !isUploading ? 'cursor-pointer' : 'cursor-default'
        }`}>
        <div className="flex-shrink-0">{getFileIcon(document.name)}</div>

        <div className="flex flex-col flex-1">
          <span className="text-sm font-medium truncate max-w-xs">
            {document.name}
          </span>
          {document.category && (
            <span className="text-xs text-gray-500">
              {t.categoryLabel.replace('{category}', document.category)}
            </span>
          )}
          {isUploading && (
            <span className="text-xs text-gray-500">
              {t.kbOf
                .replace('{used}', String(Math.round((document.uploadedSize ?? 0) / 1024)))
                .replace('{total}', String(Math.round((document.totalSize ?? 0) / 1024)))}
            </span>
          )}
          {isComplete && (
            <span className="flex items-center gap-1 text-xs text-green-600">
              <CheckCircle2 className="w-4 h-4" />
              {t.completed}
            </span>
          )}
          {isFailed && (
            <span className="flex items-center gap-1 text-xs text-red-600">
              <AlertCircle className="w-4 h-4" />
              {t.uploadFailed}
            </span>
          )}
          {isUploading && (
            <div className="mt-1 w-full bg-gray-200 rounded h-1.5">
              <div
                className="h-1.5 bg-blue-600 rounded transition-all"
                style={{ width: `${progress}%` }}
              />
            </div>
          )}
        </div>
      </div>
    </li>
  );
};
